import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SanitizeTextService {
  constructor(private domSanitizer: DomSanitizer) {}
  /**
   * Sanitizes HTML content and returns a SafeHtml object
   * @param html The HTML string to sanitize
   * @returns SafeHtml object or empty string if input is invalid
   */
  sanitizeHtml(html: string | null | undefined): SafeHtml {
    if (!html) {
      return '';
    }
    return this.domSanitizer.sanitize(SecurityContext.HTML, html) || '';
  }
}
